import axios from "axios";

const asApi = axios.create({
  baseURL: "/api/ask-stewie",
  withCredentials: true,
});

asApi.interceptors.response.use(
  (response) => {
    const moduleHeader = response.headers?.["x-module"];
    if (moduleHeader && moduleHeader !== "ask-stewie") {
      console.error(
        "WRONG MODULE RESPONSE! Expected ask-stewie but got:",
        moduleHeader,
        "URL:",
        response.config?.url
      );
    }
    return response;
  },
  (error) => Promise.reject(error)
);

export default asApi;
